
import Vue from 'vue'

export default Vue.extend({
	name: 'ConsentTitle',
	props: {
		title: {
			type: String,
			required: true
		},
		subtitle: {
			type: String,
			default: ''
		}
	}
})
